import { loadable } from 'utils';

export const Appearance = loadable(() => import('./Appearance'), {});
export const Create = loadable(() => import('./Create'), {});
export const Update = loadable(() => import('./Update'), {});
export const Maintenance = loadable(() => import('./Maintenance'), {});
